<p-card>
    <div
        *ngIf="!recordView && !createEmployeeView"
        [ngClass]="{
            'disable-for-quickview': quickview,
            '': !quickview
        }"
    >
        <div class="settings-heading">Employees</div>
        <div class="padding-16-top-bottom employee-controll-area">
            <div class="flex flex-row justify-content-start gap-4 align-items-center">
                <p-iconfield>
                    <p-inputicon styleClass="pi pi-search"></p-inputicon>
                    <input
                        type="text"
                        pInputText
                        placeholder="Search"
                        [(ngModel)]="employeeSearchTerm"
                        (ngModelChange)="filterEmployees()"
                    />
                </p-iconfield>

                <div class="flex flex-row justify-content-between gap-2 w-auto align-items-center">
                    <label class="text-sm font-semibold">Employment:</label>
                    <p-select
                        [(ngModel)]="activeEmployeeFilter"
                        [options]="activeEmployeeFilterOptions"
                        (onChange)="filterEmployees()"
                        class="w-full"
                    ></p-select>
                </div>

                <div class="flex flex-row justify-content-between gap-2 w-auto align-items-center">
                    <label class="text-sm font-semibold">User Status:</label>
                    <p-select
                        [(ngModel)]="activeUserFilter"
                        [options]="activeUserFilterOptions"
                        (onChange)="filterEmployees()"
                    ></p-select>
                </div>

                <span
                    (click)="exportToExcel(kendoGrid)"
                    title="Download Excel"
                    class="employee-export-button"
                >
                    <mat-icon fontSet="fas" fontIcon="fa-file-excel"></mat-icon>
                </span>
            </div>

            <div class="employee-add-button-area">
                <button
                    type="button"
                    mat-raised-button
                    class="convert-employees-button"
                    (click)="switchToConvertUsersView()"
                    [disabled]="disableCreateUserButton"
                >
                    &nbsp; CREATE USERS
                    <i class="fal fa-people-arrows"></i>
                </button>
                <button type="button" mat-raised-button (click)="switchToAddEmployeeView()">
                    <i class="fal fa-plus-square"></i>
                    &nbsp; ADD EMPLOYEE
                </button>
            </div>
        </div>
        <div>
            <kendo-grid
                #kendoGrid="kendoGrid"
                class="lg-kendo-grid"
                [data]="gridView"
                [loading]="loading"
                [pageSize]="pageSize"
                [skip]="skip"
                [sortable]="{
                    mode: 'single',
                    allowUnsort: false
                }"
                [sort]="employeeSort"
                (sortChange)="sortChange($event)"
                [pageable]="{
                    info: true,
                    type: type,
                    pageSizes: true,
                    previousNext: true
                }"
                [scrollable]="'scrollable'"
                (pageChange)="employeePageChange($event)"
                (cellClick)="employeeSelectionChangeHandler($event)"
            >
                <ng-template kendoGridNoRecordsTemplate>
                    <div class="no-data-message-area" *ngIf="noEmployees">
                        <no-data-screen [noDataType]="noDataType"> </no-data-screen>
                    </div>
                </ng-template>
                <kendo-grid-column
                    field="lastName"
                    title="LAST NAME"
                    [headerStyle]="{ 'text-align': 'left' }"
                    [style]="{ 'text-align': 'left' }"
                    [footerClass]="'text-color-black'"
                    [footerStyle]="{ 'text-align': 'left' }"
                >
                </kendo-grid-column>
                <kendo-grid-column
                    field="firstName"
                    title="FIRST NAME"
                    [headerStyle]="{ 'text-align': 'left' }"
                    [style]="{ 'text-align': 'left' }"
                    [footerClass]="'text-color-black'"
                    [footerStyle]="{ 'text-align': 'left' }"
                >
                </kendo-grid-column>
                <kendo-grid-column
                    field="primaryIdentifier"
                    title="EMPLOYEE NUMBER"
                    [headerStyle]="{ 'text-align': 'left' }"
                    [style]="{ 'text-align': 'left' }"
                >
                </kendo-grid-column>
                <kendo-grid-column
                    field="jobTitle"
                    title="JOB TITLE"
                    [headerStyle]="{ 'text-align': 'left' }"
                    [style]="{ 'text-align': 'left' }"
                >
                </kendo-grid-column>
                <kendo-grid-column
                    field="positionName"
                    title="Position"
                    [headerStyle]="{ 'text-align': 'left' }"
                    [style]="{ 'text-align': 'left' }"
                >
                </kendo-grid-column>
                <kendo-grid-column
                    field="employeeStatus"
                    title="EMPLOYMENT"
                    [headerStyle]="{ 'text-align': 'left' }"
                    [style]="{ 'text-align': 'left' }"
                >
                </kendo-grid-column>
                <kendo-grid-column
                    field="userStatus"
                    title="USER STATUS"
                    [headerStyle]="{ 'text-align': 'left' }"
                    [style]="{ 'text-align': 'left' }"
                >
                </kendo-grid-column>
                <kendo-grid-column
                    field="location"
                    title="LOCATION"
                    [headerStyle]="{ 'text-align': 'left' }"
                    [style]="{ 'text-align': 'left' }"
                >
                </kendo-grid-column>
                <kendo-grid-column width="80">
                    <ng-template kendoGridHeaderTemplate>
                        <input
                            type="checkbox"
                            (change)="onSelectHeaderChange()"
                            [(ngModel)]="selectHeaderState"
                            class="employee-checkbox"
                        />
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <input
                            type="checkbox"
                            [(ngModel)]="dataItem.isSelected"
                            class="employee-checkbox"
                        />
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-excel [fileName]="exportFileName" [fetchData]="getExcelExportData">
                    <kendo-excelexport-column field="lastName" title="LAST NAME">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column field="firstName" title="FIRST NAME">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column field="primaryIdentifier" title="EMPLOYEE NUMBER">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column field="jobTitle" title="JOB TITLE">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column field="loginEmail" title="EMAIL ADDRESS">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column field="positionName" title="POSITION">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column field="employeeStatus" title="EMPLOYMENT">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column field="userStatus" title="USER STATUS">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column field="location" title="LOCATION">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column field="formattedHireDate" title="HIRE DATE">
                    </kendo-excelexport-column>
                    <kendo-excelexport-column field="formattedTermDate" title="TERMINATION DATE">
                    </kendo-excelexport-column>
                </kendo-grid-excel>
                <ng-template kendoPagerTemplate>
                    <kendo-pager-prev-buttons class="text-color-black"></kendo-pager-prev-buttons>
                    <kendo-pager-input class="text-color-black"></kendo-pager-input>
                    <kendo-pager-info class="text-color-black"></kendo-pager-info>
                    <kendo-pager-next-buttons class="text-color-black"></kendo-pager-next-buttons>

                    <kendo-pager-page-sizes
                        class="text-color-black"
                        [pageSizes]="[10, 25, 50, 100]"
                    ></kendo-pager-page-sizes>
                </ng-template>
            </kendo-grid>
        </div>
    </div>
    <div class="quickview" *ngIf="quickview && !createEmployeeView">
        <div class="quickview-header">
            <span class="padding-16-left-right" style="position: relative; top: 2px">
                {{ selectedEmployee.firstName }}&nbsp;{{ selectedEmployee.lastName }}
            </span>
            <button
                id="closeQuickviewButton"
                class="padding-16-left-right"
                (click)="closeEmployeeQuickview()"
            >
                <i class="far fa-times"></i>
            </button>
        </div>
        <div id="quickviewAvatarDiv" *ngIf="quickview">
            <div style="margin-top: 16px">
                {{ selectedEmployee.firstName }}&nbsp;{{ selectedEmployee.lastName }}
            </div>
            <div style="margin-top: 4px; font-size: 0.8em">
                {{ selectedEmployee.jobTitle }}
            </div>
            <div style="margin-top: 4px; margin-bottom: 16px">
                <a href="mailto: {{ selectedEmployee.loginEmail }}">{{
                    selectedEmployee.loginEmail
                }}</a>
            </div>
        </div>
        <div id="quickviewEmployeeProperties" *ngIf="quickview">
            <div class="quickview-label">First Name</div>
            <div class="quickview-value">
                {{ selectedEmployee.firstName }}
            </div>
            <div class="quickview-label">Last Name</div>
            <div class="quickview-value">
                {{ selectedEmployee.lastName }}
            </div>
            <div class="quickview-label">Email</div>
            <div class="quickview-value">
                {{ selectedEmployee.loginEmail }}
            </div>
            <div class="quickview-label">Location</div>
            <div class="quickview-value">
                {{ selectedEmployee.location }}
            </div>
            <div class="quickview-label">City</div>
            <div class="quickview-value">{{ selectedEmployee.city }}</div>
            <div class="quickview-label">State</div>
            <div class="quickview-value">{{ selectedEmployee.state }}</div>
            <div class="quickview-label">Employment Status</div>
            <div class="quickview-value">
                {{ selectedEmployee.employeeStatus }}
            </div>
            <div class="quickview-label">User Status</div>
            <div class="quickview-value">
                {{ selectedEmployee.userStatus }}
            </div>
        </div>
        <div id="quickviewButtonDiv">
            <button
                class="margin-button"
                mat-button
                (click)="
                    addEditOrViewOnly = 'edit'; recordView = true; editing = true; quickview = false
                "
                outlined
            >
                EDIT
            </button>
            <button class="margin-button" mat-raised-button (click)="openRecordView()">
                VIEW RECORD
            </button>
        </div>
    </div>
    <div [ngClass]="{ 'middle-layer-for-page-disable': quickview }"></div>
    <app-employee-record-view
        *ngIf="recordView"
        [addEditOrViewOnly]="addEditOrViewOnly"
        [selectedEmployee]="selectedEmployee"
        [supervisors]="supervisors"
        [hierarchies]="hierarchies"
        [hierarchyListSettings]="hierarchyListSettings"
        [editing]="editing"
        (cancelClickedEvent)="handleCancelClicked()"
        (employeeModEvent)="handleEmployeeModEvent()"
        style="display: flex; flex-direction: column; position: relative"
    ></app-employee-record-view>
</p-card>
